<template>
  <highlight-container
    id="pricing"
    fluid
    :title="title"
    :subtitle="content"
    alignment="center"
    even
  >
    <HubspotForm
      form-id="2106f0fe-cdfb-4ff5-9898-0cb7630979b0"
      :on-form-submit="
        () => {
          this.$analytics('Formulário', 'sent-B2C ', 'indicacao-marca');
        }
      "
    />
    <!-- <company-indication /> -->
  </highlight-container>
</template>

<script>
export default {
  name: 'ConsumerSection2',
  components: {
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
    // CompanyIndication: () => import('@/components/Forms/CompanyIndication.vue'),
    HubspotForm: () => import('@/components/HubspotForm.vue'),
  },
  data() {
    return {
      title: 'Sentiu falta de alguma marca por aqui?',
      content: `Indique uma empresa para fazer parte desta transformação e contribua para que os investimentos na
                cadeia de reciclagem cresçam cada vez mais. Com o engajamento de todos é possível um mundo mais
                sustentável.`,
    };
  },
};
</script>

<style lang="sass" scoped>

@import '@/styles/util'
@import '@/styles/style'

.align-button
  @media screen and (max-width: $sm)
    display: flex
    align-items: center
    justify-content: center
    .v-btn
      width: 100%
</style>
